import React from 'react';
import classNames from 'classnames';
import styles from './Button.scss';
import { Spinner } from '../../molecules/spinner';

interface ButtonProps {
    id: string;
    children: React.ReactNode | React.ReactNode[],
    appearance?: 'new-primary' | 'new-warning' | 'primary' | 'icon' | 'link-secondary',
    type?: 'button' | 'submit',
    disabled?: boolean;
    isLoading?: boolean
    href?: string;
    target?: string;
    overrideClass?: string;
    width?: string;
    onClick?: () => void;
}

const Button = function Button({
    id,
    type = 'button',
    appearance,
    onClick,
    disabled,
    isLoading,
    overrideClass,
    href,
    target = '_self',
    width,
    children,
}: ButtonProps) {
    const buttonId = `${id}-button`;
    const buttonProps = {
        id: buttonId,
        'aria-label': buttonId,
        className: classNames(styles.button, overrideClass, styles[`button--${appearance}`], {
            [styles['button--is-icon']]: appearance?.startsWith('icon'),
        }),
        disabled,
        onClick,
        style: width ? ({ width }) : {},
    };

    const buttonChildren = isLoading ? <Spinner size={16} color="inherit" /> : children;

    return href ? (
        <a
            {...buttonProps}
            href={href}
            target={target}
        >
            {buttonChildren}
        </a>
    ) : (
        <button
            {...buttonProps}
            type={type === 'button' ? 'button' : 'submit'}
        >
            {buttonChildren}
        </button>
    );
};

export default Button;
